var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-5" }, [
        _c(
          "button",
          {
            staticClass: "createBtn btn-sm btn-outline-info",
            attrs: { type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("中断する")]
        ),
        _c(
          "button",
          {
            staticClass: "createBtn btn-sm btn-outline-info",
            attrs: { type: "button" },
            on: { click: _vm.create },
          },
          [_vm._v("組織を追加する")]
        ),
        _c(
          "button",
          {
            staticClass: "createBtn btn-sm btn-outline-info",
            attrs: { type: "button" },
            on: { click: _vm.copy },
          },
          [_vm._v("現状の組織を複製する")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "main" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "table",
          {
            staticClass:
              "table table-dark table-sm table-hover table-borderless",
          },
          [
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.organizations, function (organization, index) {
                return _c("tr", { key: organization.id }, [
                  _c("th", { attrs: { scope: "row" } }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
                  _c("td", [_vm._v(_vm._s(organization.displayName))]),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-sm btn-light",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.modify(organization.id)
                          },
                        },
                      },
                      [_vm._v("編集する")]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "col-3" }),
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info btn btn-block",
            attrs: { type: "button" },
            on: { click: _vm.next },
          },
          [_vm._v("次へ")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [_c("h5", [_vm._v("組織変更")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "70px" }, attrs: { scope: "col" } }, [
          _vm._v("#"),
        ]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("組織名称")]),
        _c("th", { staticStyle: { width: "150px" }, attrs: { scope: "col" } }, [
          _vm._v("操作"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }